import { useTranslation } from 'react-i18next';
import { toOrdinal } from '@/utils/ordinal';

export const useFloorFormat = () => {
  const { t, i18n } = useTranslation();

  /**
   * 階数を言語に応じてフォーマットする
   * @param floor - 階数（数値または文字列）
   * @param translationKey - 翻訳キー（デフォルト: 'common.floorUnit'）
   * @returns フォーマットされた階数文字列
   * @example
   *   日本語: "4階"
   *   英語: "4th Floor"
   */
  const formatFloor = (
    floor: number | string,
    translationKey = 'common.floorUnit',
  ): string => {
    const floorNumber = typeof floor === 'string' ? Number(floor) : floor;
    const floorUnit = t(translationKey);

    if (i18n.language === 'en') {
      return `${toOrdinal(floorNumber)} ${floorUnit}`;
    }

    return `${floor}${floorUnit}`;
  };

  return {
    formatFloor,
  };
};
